import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { httpService } from '../../../utils/apiService';

const useUpdateSetting = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options;

  return useMutation({
    mutationKey: ['UPDATE_SETTING'],
    mutationFn: async (data) => {
      const response = await httpService.post('setting/update', data);
      return response.data.data;
    },
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch settings data after successful update
      queryClient.invalidateQueries({ queryKey: ['LIST_SETTING'] });
      if (onSuccess) {
        onSuccess(data, variables, context);
      }
    },
    ...restOptions,
  });
};

const useListSetting = (options = {}) => {
  return useQuery({
    queryKey: ['LIST_SETTING'],
    queryFn: async () => {
      const response = await httpService.get('setting/list');
      return response.data.data;
    },
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};

const useUploadFirebaseSettings = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options;

  return useMutation({
    mutationKey: ['UPLOAD_FIREBASE_SETTINGS'],
    mutationFn: async (serviceAccountJson) => {
      const response = await httpService.post('setting/firebase', serviceAccountJson);
      return response.data.data;
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ['LIST_SETTING'] });
      if (onSuccess) onSuccess(data, variables, context);
    },
    ...restOptions,
  });
};

const useTestFirebaseSettings = (options = {}) =>
  useMutation({
    mutationKey: ['TEST_FIREBASE_SETTINGS'],
    mutationFn: async ({ testToken }) => {
      const response = await httpService.post('setting/firebase/test', { testToken });
      return response.data.data;
    },
    ...options,
  });

const useClearFirebaseSettings = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options;

  return useMutation({
    mutationKey: ['CLEAR_FIREBASE_SETTINGS'],
    mutationFn: async () => {
      const response = await httpService.post('setting/firebase/clear');
      return response.data.data;
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ['LIST_SETTING'] });
      if (onSuccess) onSuccess(data, variables, context);
    },
    ...restOptions,
  });
};

export { useUpdateSetting, useListSetting, useUploadFirebaseSettings, useTestFirebaseSettings, useClearFirebaseSettings };
